import { createContext, useContext } from 'react'
import CommonStore from "./CommonStore";
import UserStore from "./UserStore";
import CustomerStore from "./CustomerStore"
import WholesalerStore from "./WholesalerStore"

interface Store {
    commonStore: CommonStore;
    userStore: UserStore;
    customerStore: CustomerStore;
    wholesalerStore: WholesalerStore;
}

export const store: Store = {
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    customerStore: new CustomerStore(),
    wholesalerStore: new WholesalerStore(),
}

export const StoreContext = createContext(store);

export function useStore() {

    return useContext(StoreContext);
}